<template>
	<div>
		<Top :flag="flag"></Top>
		<div class="wd-container">
			<div class="conlist">
				<div class="row wd-flex wd-row-between">
					<div class="wd-flex wd-row-left">
						<div>
						<span>全部结果 ></span>
						</div>
						<template  v-for="(item, index) in filterlist">
							<div class="wd-flex wd-row-left filterrs" :key="index" v-if="item.select">
								<div class="wd-m-r-5">{{item.name}}: </div>
								<template v-for="(ditem,dindex) in item.value">
									<div :key="dindex" v-if="ditem.select">
										<span class="wd-theme wd-m-r-5">{{ditem.name}}</span>
									</div>
								</template>
								<div @click="clearfilter(index)"><i class="wd-icon">&#xe608;</i></div>
							</div>
						</template>
						<div class="wd-m-l-10">
						<span v-if="showname != ''" class="wd-font-bold">"{{ showname }}"</span>
						</div>
					</div>
					<div class="wd-cursor" @click="resetcon">清空筛选条件</div>
				</div>
				<div class="filtercss">
					<template v-for="(item, index) in filterlist">
						<div :key="index" class="wd-flex wd-row-between arow" v-if="item.value != ''">
							<div class="title wd-row-noshrink">{{ item.name }}：</div>
							<div class="detail wd-row-grow wd-flex wd-flex-wrap wd-row-left" :class="item.name == '品牌' ? 'scroll' : ''">
								<div class="tag" :class="item.name == '品牌' ? 'brand' : ''" v-for="(detail, dindex) in item.value" :key="dindex"  @click="setconcss(index,dindex)">
									<el-image fit="contain" class="img" :src="$wdpicurl(detail.picurl)" v-if="item.name == '品牌'"></el-image>
									{{ detail.name }}
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
			<div class="conlist2"></div>
			<div class="goodslistcontain wd-flex wd-row-around wd-col-top">
				<div class="suggest">
					<div class="title">推荐热卖</div>
					<div class="detail">
						<div class="goods wd-m-t-10" v-for="(item, index) in hotlist" :key="index"  @click="gotogoodsdetail(item.goodsid, item.goodsname)">
							<div class="wd-goods-img"><el-image :src="$wdpicurl(item.pic1)"></el-image></div>
							<div class="name wd-line-2 wd-m-t-10">{{ item.goodsname }}</div>
							<div class="price wd-theme wd-m-t-10">
								<span class="wd-theme">¥{{ item.appprice }}</span>
								<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold" v-if="item.appprice!=item.plusprice">¥{{item.plusprice}}</span>
								<span class="pluscss"  v-if="item.appprice!=item.plusprice">PLUS</span>
								<span class="wd-theme-999 wd-font-delete wd-font-12 wd-m-l-10" v-if="item.appprice==item.plusprice">¥{{ item.retailprice }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="goodslist">
					<div class="orderby">
						<div class=" wd-flex wd-row-between wd-p-l-10 wd-p-r-10">
							<div class=" wd-flex wd-row-left">
								<div class="tag" :class="order == 0 ? 'select' : ''" @click="setorder(0)">综合</div>
								<div class="tag" :class="order == 1 ? 'select' : ''" @click="setorder(1)">销量</div>
								<div class="tag wd-flex wd-row-around" :class="order == 2 ? 'select' : ''" @click="setorder(2)">
									<div class="wd-m-l-5">价格</div>
									<div class="price">
										<div><i class="wd-icon" :class="sortasc === 'asc' ? 'aselect' : ''">&#xe607;</i></div>
										<div><i class="wd-icon" :class="sortasc === 'desc' ? 'aselect' : ''">&#xe6f1;</i></div>
									</div>
								</div>
								<div class="tag" :class="order == 3 ? 'select' : ''" @click="setorder(3)">评论</div>
								<div class="tag" :class="order == 4 ? 'select' : ''" @click="setorder(4)">新品</div>
							</div>
							<div class="wd-flex wd-row-right orderbtngroup">
								<div class="wd-m-r-10">
									<span class="wd-theme-999">共{{ cnt }}个商品</span>
								</div>
								<div class="btn"><span class="wd-icon wd-font-12" @click="gopage(-1)">&#xe7dd;</span></div>
								<div class="wd-m-l-10 wd-m-r-10">
									<span class="wd-theme">{{ page }}</span>
									<span>/{{ pagecnt }}</span>
								</div>
								<div class="btn"><span class="wd-icon wd-font-12" @click="gopage(1)">&#xe606;</span></div>
							</div>
						</div>
					</div>
					<div class="detail wd-flex wd-row-left wd-flex-wrap">
						<div class="goods" v-for="(item, index) in wddatalist" :key="index" @click="gotogoodsdetail(item.goodsid, item.goodsname)">
							<div class="wd-goods-img"><el-image :src="$wdpicurl(item.pic1)"></el-image></div>
							<div class="price wd-m-t-10">
								<span class="wd-theme">¥{{ item.appprice }}</span>
								<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold" v-if="item.appprice!=item.plusprice">¥{{item.plusprice}}</span>
								<span class="pluscss"  v-if="item.appprice!=item.plusprice">PLUS</span>
								<span class="wd-theme-999 wd-font-delete wd-font-12 wd-m-l-10" v-if="item.appprice==item.plusprice">¥{{ item.retailprice }}</span>
							</div>
							<div class="name wd-line-2">{{ item.goodsname }}</div>
							<div class="wd-font-12 wd-theme-999 wd-m-t-10"><span class="wd-icon wd-font-12 wd-m-r-5">&#xe6b9;</span>{{item.branchname}}</div>
						</div>
					</div>
					<div class="wd-fr">
						<el-pagination
							:total="cnt"
							:background="true"
							layout="prev, pager, next"
							:page-size="limit"
							:small="true"
							@size-change="pagesizechange"
							@current-change="currentchange"
							@prev-click="prevclick"
							@next-click="nextclick"
						></el-pagination>
					</div>
					<!-- <div class="btngroup wd-flex wd-row-right">
						<div class="btn">上一页</div>
						<div class="btn select">1</div>
						<div class="btn">2</div>
						<div class="btn">3</div>
						<div class="btn">下一页</div>
					</div> -->
				</div>
			</div>
		</div>
		<div class="like wd-container">
			<div class="title wd-flex wd-row-between ">
				<div>猜你喜欢</div>
				<div @click="changesuggest(6)" class="wd-cursor">
					<i class="wd-icon">&#xe62f;</i>
					<span class="wd-m-l-10">换一换</span>
				</div>
			</div>
			<div class="detail wd-flex wd-row-left wd-flex-wrap">
				<div class="goods" v-for="(item, index) in suggestlist" :key="index" @click="gotogoodsdetail(item.goodsid, item.goodsname)">
					<div class="wd-goods-img"><el-image :src="$wdpicurl(item.pic1)"></el-image></div>
					<div class="name wd-line-1 wd-m-t-10">{{ item.goodsname }}</div>
					<div class="wd-m-t-10">
						<span class="wd-theme">¥{{ item.appprice|amountFormatter }}</span>
						<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold" v-if="item.appprice!=item.plusprice">¥{{item.plusprice|amountFormatter}}</span>
						<span class="pluscss"  v-if="item.appprice!=item.plusprice">PLUS</span>
						<span class="wd-theme-999 wd-font-delete wd-font-12 wd-m-l-10" v-if="item.appprice==item.plusprice">¥{{ item.retailprice|amountFormatter }}</span>

					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Goodslist',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			wddatalist: [],
			hotlist: [],
			flag: '1',
			order: '0',
			cnt: -1,
			page: 0,
			pagecnt: 0,
			limit: 40,
			sort: '',
			sortasc: 'asc',
			suggestlist: [],
			filterlist: [],
			filtercon: [],
			showname: '',
			uselevellist: [],
			useagelist: [],
			brandlist: [],
			classid: '',
			contype: '4'
		};
	},
	watch: {
		$route() {
			var param = this.$route.params;
			if (this.$weidajs.isEmpty(param)) {
				param = this.$route.query;
			}
			var flag = param.flag || '';
			var con = param.con||'';
			// if (((flag !== '' && this.flag!=flag)) || (this.con!=con)) {
				this.con=con;
				this.flag = flag;
				this.order = '0';
				this.sort = '';
				this.sortasc = 'asc';
				this.contype = param.contype || '4';
				this.con = param.con || '';
				this.classid = param.classid || '';
				this.showname = param.showname || '';
				this.resetcon();
				this.cnt = -1;
				this.loaddata();
			// }
		}
	},
	methods: {
		clearfilter(index){
			var list=this.filterlist[index];
			list.select=false;
			for (var i =0; i <list.value.length;i++) {
				list.value[i].select=false;
				
			}
			this.$set(this.filterlist,index,list);
			this.cnt=-1;
			this.loaddata();
		},
		resetcon(){
			var list=this.filterlist;
			for (var i =0; i <list.length;i++) {
				var item=list[i]
				item.select=false;
				for (let j in item.value) {
					list[i].value[j].select=false;
				}
				this.$set(this.filterlist,i,item)
			}
			this.cnt=-1;
			this.loaddata();
		},
		setconcss(filterindex,index){
			let item=this.filterlist[filterindex].value[index];
			item.select=!item.select;
			this.$set(this.filterlist[filterindex].value,index,item);
			this.filterlist[filterindex].select=true;
			this.cnt=-1;
			this.loaddata();
		},
		setcss(index) {
			this.classindex = index;
		},
		changesuggest(cnt) {
			var arr = this.hotlist;
			var shuffled = arr.slice(0),
				i = arr.length,
				min = i - cnt,
				temp,
				index;
			while (i-- > min) {
				index = Math.floor((i + 1) * Math.random());
				temp = shuffled[index];
				shuffled[index] = shuffled[i];
				shuffled[i] = temp;
			}
			this.suggestlist = shuffled.slice(min);
		},
		gopage(page) {
			if (page < 0) {
				if (this.page <= 1) {
					return;
				} else {
					this.page--;
				}
			} else {
				if (page == this.pagecnt) {
					return;
				} else {
					this.page++;
				}
			}
			this.page--;
			this.loaddata();
		},
		pagesizechange(e) {
			this.page = e - 1;
			this.loaddata();
		},
		currentchange(e) {
			this.page = e - 1;
			this.loaddata();
		},
		prevclick(e) {
			this.page = e - 1;
			this.loaddata();
		},
		nextclick(e) {
			this.page = e - 1;
			this.loaddata();
		},
		setorder(a) {
			this.order = a;
			if (a == 0) {
				this.sort = '';
			} else if (a == 1) {
				this.sort = 'salenum';
			} else if (a == 2) {
				this.sort = 'retailprice';
			} else if (a == 3) {
				this.sort = 'commentnum';
			} else if (a == 4) {
				this.sort = 'createdate';
			}
			if (this.sortasc === 'asc') {
				this.sortasc = 'desc';
			} else {
				this.sortasc = 'asc';
			}
			this.cnt = -1;
			this.page = 0;
			this.loaddata();
		},
		loaddata() {
			if (this.contype=='4' && this.con==''){
				return;
			}
			if (this.cnt == -1) {
				this.page = 1;
			} else {
				if (this.page * this.limit >= this.cnt) {
					return;
				} else this.page++;
			}
			var list=this.filterlist;
			this.filtercon=[];
			for (var i =0; i <list.length;i++) {
				var item=list[i]
				var con={
					type:item.type,
					value:[]
				}
				for (let j in item.value) {
					if (list[i].value[j].select){
						var val= list[i].value[j].name;
						con.value.push(val);
					}
				}
				if (con.value.length>0){
					this.filtercon.push(con);
				}
			}
			if (this.flag==2){
				this.con="母婴";
				this.contype="4";
			}else if (this.flag==3){
				this.con="奶粉";
				this.contype="4";
			}else if (this.flag==4){
				this.con="辅食";
				this.contype="4";
			}
			var indata = {
				cnt: this.cnt,
				page: this.page,
				limit: this.limit,
				contype: this.contype,
				con: this.con,
				sort: this.sort,
				sortasc: this.sortasc,
				classid: this.classid,
				filter: this.filtercon
			};
			this.$wd_request('goodslist', indata, true, '.goodslist')
				.then(data => {
					if (this.cnt == -1) {
						this.wddatalist = data.value;
						this.cnt = data.cnt;
						this.pagecnt = Math.ceil(data.cnt / this.limit);
						this.loadfilter(data.value[0].goodsid);
					} else {
						this.wddatalist = data.value;
						// this.wddatalist = this.wddatalist.concat(data.value);
					}
				})
				.catch(() => {
					if (this.cnt===-1){
						this.cnt=0;
						this.pagecnt=0;
					}
				});
		},
		loadhot() {
			this.$wd_request('goodslist', { contype: 1 }).then(data => {
				this.hotlist = data.value;
				this.changesuggest(6);
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		loadfilter(goodsid) {
			// if (this.$weidajs.isEmpty(this.filterlist)){
				var indata = {
					con: this.con,
					classid: this.classid,
					contype: this.contype,
					goodsid: goodsid
				};
				this.$wd_request('app_goods_filter',  indata).then(data => {
					this.filterlist = data.value;
				});
			// }
		}
	},
	created() {
		var param = this.$route.params;
		if (this.$weidajs.isEmpty(param)) {
			param = this.$route.query;
		}
		var flag = param.flag || '';
		if (flag !== '') {
			this.flag = flag;
		}
		this.contype = param.contype || '4';
		this.con = param.con || '';
		this.classid = param.classid || '';
		this.showname = param.showname || '';
		this.loaddata();
		this.loadhot();
	}
};
</script>

<style lang="scss" scoped>
.conlist {
	margin-bottom: 40px;
	.row {
		height: 40px;
		line-height: 40px;
	}
	.filterrs{
		position: relative;
		float: left;
		height: 22px;
		line-height: 22px;
		border: 1px solid #DDD;
		font-size: 12px;
		vertical-align: top;
		margin: 0 5px 5px 0;
		padding: 0 6px 0 4px;
		cursor: pointer;
		background: #f3f3f3;
		.wd-icon{
			color: $wd-theme;
			font-size: 12px;
		}
		&:hover{
			border: 1px solid $wd-theme;
			.wd-icon{
				background-color: $wd-theme;
				color: #FFFFFF;
			}
		}
			
	}
	.filtercss {
		border-top: 1px solid $wd-border;
		.arow {
			border-bottom: 1px solid $wd-border;
			background-color: #f7f7f7;
			.title {
				padding: 10px 0 10px 30px;
				width: 150px;
				font-weight: 600;
				color: #666666;
			}
			.detail {
				background-color: #ffffff;
				padding: 10px;
				margin-left: 10px;
				&.scroll{
					height: 92px;
					overflow-y: scroll;
				}
				.tag {
					margin-right: 20px;
					color: #005aa0;
					&:hover {
						cursor: pointer;
						color: $wd-theme;
					}
					&.brand {
						overflow: hidden;
						width: 114px;
						height: 48px;
						line-height: 48px;
						padding: 0;
						border: 1px solid #ddd;
						// margin: -1px -1px 0 0;
						margin:0;
						background: #fff;
						text-align: center;
						&:hover {
							border-color: $wd-theme;
							// margin-right: 1px;
							// margin-bottom: 1px;
							box-shadow: 2px 2px 3px rgba(0,0,0,.12); 
							.img {
								display: none;
							}
						}
						.img {
							width: 114px;
							height: 48px;
							display: block;
						}
					}
				}
			}
		}
	}
}
.goodslistcontain {
	.suggest {
		width: 190px;
		border: 1px solid #eaeaea;
		.title {
			height: 40px;
			width: 180px;
			background: #f7f7f7;
			line-height: 40px;
			overflow: hidden;
			padding-left: 10px;
		}
		.detail {
			padding: 0 5px;
			.goods {
				padding: 10px;
				.img {
					width: 180px;
					height: 180px;
					margin: 0 auto;
				}
				.name {
					height: 36px;
				}
				.price {
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 0 2px 2px #f8f8f8;
					border: 1px solid #e9e9e9;
					// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
	.goodslist {
		margin-left: 20px;
		flex-grow: 1;
		align-items: top;
		border: 1px solid #eaeaea;
		.orderby {
			height: 40px;
			width: 100%;
			background: #f7f7f7;
			line-height: 40px;
			overflow: hidden;
			.tag {
				width: 48px;
				height: 26px;
				border: 1px solid #cfcfcf;
				line-height: 26px;
				margin-right: -1px;
				background: #fff;
				font-size: 12px;
				text-align: center;
				cursor: pointer;
				.price {
					line-height: 0.5;
					.wd-icon {
						font-size: 10px !important;
						color: #999;
					}
				}
				&:hover {
					border-color: #e23435;
					margin-right: 0;
				}
				&.select {
					background-color: #e23435;
					border-color: #e23435;
					color: #ffffff;
					.wd-icon {
						color: #999;
						&.aselect {
							color: #ffffff;
						}
					}
				}
			}
			.orderbtngroup {
				.btn {
					width: 19px;
					height: 18px;
					border: 1px solid #eaeaea;
					display: block;
					background: #fff;
					font-size: 14px;
					font-weight: 700;
					color: #666;
					line-height: 20px;
					text-align: center;
					&.select,
					&:hover {
						background-color: #e23435;
						border-color: #e23435;
						color: #ffffff;
					}
					&:hover {
						cursor: pointer;
					}
				}
			}
			.cnt {
			}
		}
		.detail {
			.goods {
				padding: 0 10px;
				width: 236px;
				padding: 10px 5px;
				margin-top: 10px;
				.goodsimg {
					width: 100%;
					height: 0;
					padding-top: 100%;
					position: relative;
					.img {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
					}
				}
				.name {
					font-size: 14px;
					height: 36px;
				}
				.price {
					font-size: 18px;
					padding: 5px 0;
				}
				&:hover {
					cursor: pointer;
					box-shadow: 0 0 2px 2px #f8f8f8;
					border: 1px solid #e9e9e9;
					// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
		.btngroup {
			margin: 10px 0;
			.btn {
				margin-right: 5px;
				font-size: 14px;
				color: #333;
				border: 1px solid #ddd;
				background-color: #f7f7f7;
				background-repeat: repeat-x;
				height: 36px;
				line-height: 36px;
				padding: 0 14px;
				display: block;
				&.select,
				&:hover {
					background-color: #e23435;
					border-color: #e23435;
					color: #ffffff;
				}
				&:hover {
					cursor: pointer;
				}
			}
		}
	}
}
.like {
	margin-top: 20px;
	.title {
		background-color: #fafafa;
		padding: 0 20px;
		font-size: 20px;
		font-weight: 500;
		color: #000;
		line-height: 50px;
		overflow: hidden;
		text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
		white-space: nowrap;
	}
	.detail {
		border-left: 0;
		border-top: 1px solid #eee;
		.goods {
			-moz-box-sizing: border-box;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			border: 1;
			padding: 20px 0;
			height: 250px;
			width: 16%;
			margin-right: 0.6%;
			margin-bottom: 3px;
			background-color: #ffffff;
			padding: 10px;
			.goodsimg {
				width: 100%;
				height: 0;
				padding-top: 100%;
				position: relative;
				.img {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
			.name {
				font-size: 14px;
			}
			.price {
				font-size: 18px;
				color: #e23435;
				padding: 5px 0;
			}
			&:hover {
				cursor: pointer;
				&:hover {
					cursor: pointer;
					box-shadow: 0 0 2px 2px #f8f8f8;
					// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); //基础投影
					//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)//浅色投影
				}
			}
		}
	}
}
</style>
